import { render } from "./vision.vue?vue&type=template&id=d082964a&scoped=true"
import script from "./vision.vue?vue&type=script&lang=js"
export * from "./vision.vue?vue&type=script&lang=js"

import "./vision.vue?vue&type=style&index=0&id=d082964a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d082964a"

export default script